import { BrandConfigKey, BrandConfigValue } from './components/brand-settings-screen/brand-settings.view-model';
import { createReducer, on } from '@ngrx/store';
import * as Actions from './brand-settings.actions';

export const featureKey = 'cxbBrandSettings';

export interface FeatureState {
  loading: boolean;
  brandConfigKeys: BrandConfigKey[];
  brandConfigValues: BrandConfigValue[];
}

export interface AppState {
  [featureKey]: FeatureState;
}

export const initialState: FeatureState = {
  loading: false,
  brandConfigKeys: [],
  brandConfigValues: [],
};

export const reducer = createReducer(
  initialState,
  on(Actions.fetchBrandConfigKeys, (state) => ({ ...state, loading: true })),
  on(Actions.fetchBrandConfigKeysSuccess, (state, action) => ({ ...state, brandConfigKeys: action.brandConfigKeys, loading: false })),
  on(Actions.fetchBrandConfigKeysFail, (state): FeatureState => ({ ...state, loading: false })),

  on(Actions.fetchBrandConfigValues, (state) => ({ ...state, loading: true })),
  on(Actions.fetchBrandConfigValuesSuccess, (state, action) => ({ ...state, brandConfigValues: action.brandConfigValues, loading: false })),
  on(Actions.fetchBrandConfigValuesFail, (state): FeatureState => ({ ...state, loading: false })),

  on(Actions.updateBrandConfig, (state) => ({ ...state, loading: true })),
  on(Actions.updateBrandConfigSuccess, (state, action) => ({ ...state, loading: false })),
  on(Actions.updateBrandConfigFail, (state): FeatureState => ({ ...state, loading: false }))
);
